module.exports = __webpack_public_path__ + "static/media/puzzle-26-bg.92b96a25.svg";